module.exports = __webpack_public_path__ + "img/icn_upload.8a2afcbd.svg";